export function useAdtier0Keys(obj: object): [string[]] {
  const values = Object.values(obj);
  const keys = values.filter(
    (v) => isNaN(v) && v !== 'INVALID' && v !== 'FIRST' && v !== 'LAST',
  );

  return [keys];
}
